const firedElement = new Set()
let firedTimeout: ReturnType<typeof setTimeout>

export function noise (data:() => void = () => data, timer?: number):void {
  if (firedElement.has(String(data))) return
  firedElement.add(String(data))
  setTimeout(() => {
    firedElement.delete(String(data))
  }, timer || 960)
  return data()
}

export function delay (data:() => void = () => data, timer?: number):void {
  if (firedElement.has(String(data))) return
  firedElement.add(String(data))
  setTimeout(() => {
    firedElement.delete(String(data))
    return data()
  }, timer || 960)
}

export function debounce (data:() => void = () => data, timer?: number):void {
  if (firedElement.has(String(data))) {
    clearTimeout(firedTimeout)
  } else {
    firedElement.add(String(data))
  }

  firedTimeout = setTimeout(() => {
    firedElement.delete(String(data))
    return data()
  }, timer || 960)
}
